import PropTypes from 'prop-types';
import 'index.css';
import {setConfiguration} from 'react-grid-system';

setConfiguration({
  breakpoints: [600, 960, 1280, 1920],
  gutterWidth: 0,
});

export default function AppContent(props) {
  const {children, classes} = props;
  const classNameMarginTopLeftZero = 'printMarginLeftZero printMarginTopZero';

  return (
    <main
      className={` ${classes.content} ${classNameMarginTopLeftZero} printHeightAuto `}
    >
      <div className={` printDisplayNone ${classes.toolbar}`} />
      {children}
    </main>
  );
}

AppContent.propTypes = {
  children: PropTypes.element.isRequired,
  classes: PropTypes.object.isRequired,
};
